import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export interface CalcFieldProps {
  domId: string;
  label: string;
  suffix?: string;
  value: string;
  onChange: (value: string) => void;
}

/** Labeled numeric input with an optional trailing unit (e.g. "% p.a."). */
export function CalcField({
  domId,
  label,
  suffix,
  value,
  onChange,
}: CalcFieldProps) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={domId} className="text-muted-foreground">
        {label}
      </Label>
      <div className="relative">
        <Input
          id={domId}
          type="number"
          inputMode="decimal"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={suffix ? "pr-14" : undefined}
        />
        {suffix && (
          <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-sm text-muted-foreground">
            {suffix}
          </span>
        )}
      </div>
    </div>
  );
}
